import React from 'react';
import Login from './Login';

const Intro = () => {
    return (
        <div>
            <div class="block"></div>
            <Login/>
        </div>
    );
};

export default Intro;
